export default "__VITE_ASSET__DXBXFddc__"